import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import OrganizationsMultiSelect from '@/components/v2/molecules/admin/tabs/AdminDashboardTab/OrganizationsMultiSelect';
import PropertiesMultiSelect from '@/components/v2/molecules/admin/tabs/AdminDashboardTab/PropertiesMultiSelect';
import { useOrganizations } from '@/hooks/useOrganizations';
import { useProperties } from '@/hooks/useProperties';
import { useContracts } from '@/hooks/useContracts';
import { useMemo } from 'react';

interface ContractsFiltersProps {
  organizationIds: string[];
  onOrganizationIdsChange: (ids: string[]) => void;
  propertyIds: string[];
  onPropertyIdsChange: (ids: string[]) => void;
  adminType: string;
  onAdminTypeChange: (type: string) => void;
}

const ContractsFilters = ({
  organizationIds,
  onOrganizationIdsChange,
  propertyIds,
  onPropertyIdsChange,
  adminType,
  onAdminTypeChange,
}: ContractsFiltersProps) => {
  const { data: organizations = [] } = useOrganizations();
  const { data: properties = [] } = useProperties();
  const { data: contracts = [] } = useContracts();

  // Filter properties based on selected organizations (cascading)
  const filteredProperties = useMemo(() => {
    if (organizationIds.length === 0) return properties;

    const propertyIdsInOrgs = contracts
      .filter(
        (contract) =>
          contract.status === 'active' &&
          contract.organization_id &&
          organizationIds.includes(contract.organization_id)
      )
      .map((contract) => contract.property_id);

    return properties.filter((property) =>
      propertyIdsInOrgs.includes(property.id)
    );
  }, [properties, contracts, organizationIds]);

  return (
    <div className="flex items-center gap-2">
      <OrganizationsMultiSelect
        organizations={organizations}
        selectedOrganizations={organizationIds}
        onSelectionChange={onOrganizationIdsChange}
      />

      <PropertiesMultiSelect
        properties={filteredProperties}
        selectedProperties={propertyIds}
        onSelectionChange={onPropertyIdsChange}
      />

      <Select value={adminType} onValueChange={onAdminTypeChange}>
        <SelectTrigger className="w-[180px] rounded-full bg-gray-100 hover:bg-gray-200 border-0 transition-colors">
          <SelectValue placeholder="Tipo de Admin" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos los tipos</SelectItem>
          <SelectItem value="Propio">Propio</SelectItem>
          <SelectItem value="Renta">Renta</SelectItem>
          <SelectItem value="Administración">Administración</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default ContractsFilters;
